import React from 'react';
import { useTranslation } from 'react-i18next';

interface MerchantContactInfoLineProps {
  text: string | null;
  testId: string;
  phoneNumber?: string;
}

const MerchantContactInfoLine: React.FC<MerchantContactInfoLineProps> = ({
  text,
  testId,
  phoneNumber,
}) => {
  const { t } = useTranslation();

  const phoneNumberLabel = `${
    phoneNumber
      ? t('profile.merchantProfile.contactInfoLine.phoneNumberLabel', {
          phoneNumber,
        })
      : ''
  }`;

  return (
    <p
      className="paragraph-20 text-black/[.55] m-0 whitespace-pre-wrap"
      data-testid={testId}
    >
      {text}{' '}
      {phoneNumber && (
        <a
          aria-label={phoneNumberLabel}
          href={`tel:${phoneNumber}`}
          className="text-black"
        >
          {phoneNumber}
        </a>
      )}
    </p>
  );
};

export default MerchantContactInfoLine;
